import App from 'src/app';
import { Theme } from 'src/components/theme';

export const HomePage = () => (
  <Theme>
    <div className="page">
      <App />
    </div>
  </Theme>
);
